// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-removal-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60px;
}

.contact-removal-avatar-wrapper {
  height: 40px;
  width: 40px;
  margin: 10px;
  position: relative;
}

.contact-removal-avatar {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.contact-removal-close {
  z-index: 0;
  display: inline-block;
  position: absolute;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  height: 16px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  background-color: rgb(242, 242, 242);
  border-radius: 50%;
  border: 0px solid rgb(0, 0, 0);
  outline: none;
  cursor: pointer;
  user-select: none;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  width: 16px;
  line-height: 8px;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 1px inset;
  top: -2px;
  right: -2px;
}

.contact-removal-close span {
  display: inline-block;
  box-sizing: border-box;
  font-size: 11px;
  line-height: 11px;
  width: 11px;
  text-align: center;
  vertical-align: middle;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
}

.contact-removal-name {
  font-family: Roboto, sans-serif;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}

.contact-removal-list {
  height: 100%;
  width: 100%;
  overflow-x: auto;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/ContactRemovalList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gDAAgD;EAChD,WAAW;EACX,gBAAgB;EAChB,kDAAkD;EAClD,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB","sourcesContent":[".contact-removal-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n}\n\n.contact-removal-avatar-wrapper {\n  height: 40px;\n  width: 40px;\n  margin: 10px;\n  position: relative;\n}\n\n.contact-removal-avatar {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.contact-removal-close {\n  z-index: 0;\n  display: inline-block;\n  position: absolute;\n  box-sizing: border-box;\n  padding: 0px;\n  margin: 0px;\n  height: 16px;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  text-transform: uppercase;\n  background-color: rgb(242, 242, 242);\n  border-radius: 50%;\n  border: 0px solid rgb(0, 0, 0);\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  width: 16px;\n  line-height: 8px;\n  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 1px inset;\n  top: -2px;\n  right: -2px;\n}\n\n.contact-removal-close span {\n  display: inline-block;\n  box-sizing: border-box;\n  font-size: 11px;\n  line-height: 11px;\n  width: 11px;\n  text-align: center;\n  vertical-align: middle;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.contact-removal-name {\n  font-family: Roboto, sans-serif;\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n}\n\n.contact-removal-list {\n  height: 100%;\n  width: 100%;\n  overflow-x: auto;\n  background-color: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
